export default __webpack_public_path__ + "static/media/0146.998ef9b0.png";